// Estilos para el contenedor principal
export const cajaContenedorPrimeroStyle = {
  width: '65vh',
  height: '100%',
  marginLeft: '10vh',
  opacity: 1
}